module.exports = __webpack_public_path__ + "static/logo-chitf-2x-fa595d363b90d97cb21675296f832b0c.png";